const regExpChinese = /^[\u4e00-\u9fa5]{0,}$/g
const regExpEnglish = /^[a-zA-Z\,.]{0,}$/g
const regExpDate = /^[1-9][0-9]{1,3}-[0-9]{2}-[0-9]{2}$/g
const regExpEmial = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g
const regExpWebsite = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/g
const regExpPhoneNumber = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/g
// const regExpTelphoneNumber = /0\d{2,3}-\d{7,8}/g
const regExpIDChard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/g
const regExpQqNumber = /^[1-9][0-9]{4,14}$/g

const validateChinese = (rule, value = '', callback) => {
  if (!regExpChinese.test(value.trim())) {
    callback(new Error('请输入中文'))
  } else {
    regExpChinese.lastIndex = 0
    callback()
  }
}
const validateEnglish = (rule, value = '', callback) => {
  if (!regExpEnglish.test(value)) {
    callback(new Error('请输入英文'))
  } else {
    regExpEnglish.lastIndex = 0
    callback()
  }
}
const validateEmial = (rule, value = '', callback) => {
  if (!regExpEmial.test(value.trim())) {
    callback(new Error('请输入邮箱'))
  } else {
    regExpEmial.lastIndex = 0
    callback()
  }
}
const validateDate = (rule, value = '', callback) => {
  if (!regExpDate.test(value.trim())) {
    callback(new Error('请输入日期（如2018-04-26）'))
  } else {
    regExpDate.lastIndex = 0
    callback()
  }
}
const validateWebsite = (rule, value = '', callback) => {
  if (!regExpWebsite.test(value)) {
    callback(new Error('请输入网站'))
  } else {
    regExpWebsite.lastIndex = 0
    callback()
  }
}
const validatePhoneNumber = (rule, value = '', callback) => {
  if (!regExpPhoneNumber.test(value)) {
    callback(new Error('请输入手机号码'))
  } else {
    regExpPhoneNumber.lastIndex = 0
    callback()
  }
}
/* const validateTelphoneNumber = (rule, value = '', callback) => {
  if (!regExpTelphoneNumber.test(value)) {
    callback(new Error('请输入电话号码'))
  } else {
    regExpTelphoneNumber.lastIndex = 0
    callback()
  }
} */
const validateIDCard = (rule, value = '', callback) => {
  if (!regExpIDChard.test(value)) {
    callback(new Error('请输入身份证号码'))
  } else {
    regExpIDChard.lastIndex = 0
    callback()
  }
}
const validateInit = (rule, value = '', callback) => {
  callback()
}
/* const isMobile = () => {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) || getComputedStyle(document.getElementById('app')).width <= 768) {
    return true
  } else {
    return false
  }
} */

export default {
  chinese: validateChinese,
  date: validateDate,
  website: validateWebsite,
  IDCard: validateIDCard,
  phoneNumber: validatePhoneNumber,
  telephoneNumber: validatePhoneNumber,
  qqNumber: regExpQqNumber,
  emial: validateEmial,
  english: validateEnglish,
  chinesdatee: validateChinese,
  validateInit
}



// WEBPACK FOOTER //
// ./src/utils/constvlus.js